import axiosClient from '../../../components/api/axiosClient';
import { buildDirectPaymentLinkUrl } from '../../../config/billetterie';

function withPublicUrl(link) {
    if (!link) return null;
    return {
        ...link,
        public_url: link.public_url || buildDirectPaymentLinkUrl(link.token),
    };
}

export async function fetchPaymentLinks() {
    const response = await axiosClient.get('/dashboard/payment-links');
    const links = (response.data?.data || []).map(withPublicUrl);
    const stats = response.data?.stats || getPaymentLinksStats(links);
    return { links, stats, noContent: Boolean(response.data?.noContent) };
}

export async function fetchPaymentLinkById(id) {
    const response = await axiosClient.get(`/dashboard/payment-links/${id}`);
    return withPublicUrl(response.data?.data || null);
}

export async function createPaymentLink(payload) {
    const body = {
        event_id: payload.event_id,
        pricing_mode: payload.pricing_mode || 'pass',
        ticket_id: payload.ticket_id || null,
        quantity: payload.quantity || 1,
        custom_amount: payload.custom_amount ?? payload.unit_price ?? null,
        custom_label: payload.custom_label || null,
        recipient_name: payload.recipient_name || null,
        recipient_phone: payload.recipient_phone || null,
        recipient_email: payload.recipient_email || null,
        note: payload.note || null,
        expires_at: payload.expires_at,
        max_uses: Number(payload.max_uses) || 1,
    };

    const response = await axiosClient.post('/dashboard/payment-links', body);
    return withPublicUrl(response.data?.data || null);
}

export async function cancelPaymentLink(id) {
    const response = await axiosClient.post(`/dashboard/payment-links/${id}/cancel`);
    return withPublicUrl(response.data?.data || null);
}

export async function updatePaymentLinkRecipient(id, payload) {
    const response = await axiosClient.put(`/dashboard/payment-links/${id}/recipient`, {
        recipient_name: payload.recipient_name ?? null,
        recipient_phone: payload.recipient_phone ?? null,
        recipient_email: payload.recipient_email ?? null,
        note: payload.note ?? null,
    });
    return withPublicUrl(response.data?.data || null);
}

export function getPaymentLinksStats(links = []) {
    const active = links.filter((l) => l.status === 'active').length;
    const paid = links.filter((l) => l.status === 'paid').length;
    const pending = links.filter((l) => l.status === 'active' || l.status === 'exhausted').length;
    const collected = links
        .filter((l) => l.status === 'paid')
        .reduce((sum, l) => sum + (Number(l.total_amount) || (Number(l.unit_price) || 0) * (Number(l.quantity) || 0)), 0);

    return { active, paid, pending, collected, total: links.length };
}

export const STATUS_META = {
    active: {
        label: 'Actif',
        className: 'bg-emerald-100 text-emerald-800 dark:bg-emerald-500/15 dark:text-emerald-300',
    },
    paid: {
        label: 'Payé',
        className: 'bg-primary-100 text-primary-800 dark:bg-primary-500/15 dark:text-primary-200',
    },
    expired: {
        label: 'Expiré',
        className: 'bg-slate-100 text-slate-600 dark:bg-slate-700 dark:text-slate-300',
    },
    cancelled: {
        label: 'Annulé',
        className: 'bg-rose-100 text-rose-700 dark:bg-rose-500/15 dark:text-rose-300',
    },
    exhausted: {
        label: 'Épuisé',
        className: 'bg-amber-100 text-amber-800 dark:bg-amber-500/15 dark:text-amber-200',
    },
};
